import React, { useRef, useState } from "react";
import classes from "./style.module.css";
import { IoCloudUploadOutline } from "react-icons/io5";
import { baseURL } from "../../../../../assets/constants/baseUrl";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { IoFolderOpenOutline } from "react-icons/io5";
import errorHandler from "../../../../../assets/utils/ErrorHandler";

const FileUploader = ({ uploadedFiles, setUploadedFiles, file }) => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uploadedFile, setUploadedFile] = useState();

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop: (acceptedFiles) => handleFileUpload(acceptedFiles),
    noClick: true,
    multiple: false,
  });

  const handleFileUpload = async (files) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file", file);
    });
    try {
      setLoading(true);
      const response = await axios.post(
        `${baseURL}file/upload/user?ticketId=${localStorage.getItem("Ticket")}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("UserToken")}`,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
          },
        }
      );
      setUploadedFile(response.data.file);
      setUploadedFiles((prevFiles) => [...prevFiles, response.data.file]);
    } catch (error) {
      errorHandler(error);
      setProgress(0);
    } finally {
      setLoading(false);
      setProgress(0);
    }
  };

  const handleremove = (item) => {
    setUploadedFile();
    const filteredItems = uploadedFiles.filter((itm) => itm.name !== item);
    setUploadedFiles(filteredItems);
  };

  return (
    <>
      <div className="mt-2">
        <p>{file}</p>
      </div>
      <div {...getRootProps()} className={classes.uploadContainer}>
        <input {...getInputProps()} style={{ display: "none" }} />

        <IoCloudUploadOutline color="#6949FF" fontSize={"50px"} />
        {!uploadedFile && (
          <button onClick={!loading && open}>
            {loading ? `درحال بارگزاری ${progress}%` : "بارگزاری فایل"}
          </button>
        )}
        {uploadedFile && (
          <>
            <div className="d-flex ">
              {uploadedFile.name}
              <IoFolderOpenOutline color="#6949FF" className="mr-3" />
            </div>
            <span
              className={classes.removeText}
              onClick={() => handleremove(uploadedFile.name)}
            >
              حذف
            </span>
          </>
        )}
      </div>
    </>
  );
};

export default FileUploader;
